import React from 'react';
import { Loader2, Target, BarChart3, Edit3 } from 'lucide-react';

const LoadingSpinner = ({ isLoading, progress, currentStep }) => {
  const steps = [
    { id: 'analyzing', label: '分析句子結構', icon: Target },
    { id: 'generating_quiz', label: '生成測驗題目', icon: BarChart3 },
    { id: 'creating_exercises', label: '創建改寫練習', icon: Edit3 }
  ];

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <Loader2 className="animate-spin h-8 w-8 text-blue-600" />
          </div>
          
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            AI 正在分析句子結構...
          </h3>
          
          <div className="mb-4">
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <div className="text-sm text-gray-600 mt-2">
              {progress}% 完成
            </div>
          </div>

          <div className="space-y-2">
            {steps.map((step, index) => {
              const Icon = step.icon;
              const isActive = currentStep === step.id;
              const isCompleted = index < steps.findIndex(s => s.id === currentStep);
              
              return (
                <div 
                  key={step.id}
                  className={`flex items-center p-2 rounded ${
                    isActive ? 'bg-blue-50 border border-blue-200' : 
                    isCompleted ? 'bg-green-50 border border-green-200' : 
                    'bg-gray-50 border border-gray-200'
                  }`}
                >
                  <div className={`mr-3 ${
                    isActive ? 'text-blue-600' : 
                    isCompleted ? 'text-green-600' : 
                    'text-gray-400'
                  }`}>
                    {isCompleted ? (
                      <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      </div>
                    ) : (
                      <Icon size={20} />
                    )}
                  </div>
                  <span className={`text-sm ${
                    isActive ? 'text-blue-700 font-medium' : 
                    isCompleted ? 'text-green-700' : 
                    'text-gray-500'
                  }`}>
                    {step.label}
                  </span>
                </div>
              );
            })}
          </div>

          <div className="text-xs text-gray-500 mt-4">
            請稍候，AI 正在處理您的請求...
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner; 